import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const FriendReferralOtp = lazy(
    () => import('../components/FriendReferralOtp')
);

const friendReferralOtp: RouteObject = {
    path: '/settings/modules/friend-referral/otp-config',
    element: <FriendReferralOtp />,
};

export default friendReferralOtp;
